module.exports = __webpack_public_path__ + "static/media/faq-icon-mobile-active.c96016bb.svg";